import Title from "../../common/Title";
import content from "app-content";

const CustomerItemsTitle = () => (
  <Title titleText={content.saved_items_application_title} />
);

export default CustomerItemsTitle;
